import { render, staticRenderFns } from "./FilesGrid.vue?vue&type=template&id=71c8429a&scoped=true&"
import script from "./FilesGrid.vue?vue&type=script&lang=js&"
export * from "./FilesGrid.vue?vue&type=script&lang=js&"
import style0 from "./FilesGrid.vue?vue&type=style&index=0&id=71c8429a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8429a",
  null
  
)

export default component.exports